(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let panels = [], pending = false;
  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
  function update() {
    pending = false;
    const header = document.querySelector('.site-header');
    const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
    for (const panel of panels) {
      const rect = panel.getBoundingClientRect();
      if (reduced.matches) {
        panel.style.removeProperty('--campaign-image-shift');
        panel.style.removeProperty('--campaign-text-shift');
        continue;
      }
      if (rect.bottom < 0 || rect.top > innerHeight) continue;
      // Keep the title inside its photograph as it follows the sticky header.
      const title = panel.querySelector('h2');
      const caption = panel.querySelector('.campaign-panel-text p');
      const textHeight = (title?.offsetHeight || 0) + (caption ? caption.offsetHeight + 18 : 0);
      const limit = Math.max(0, (rect.height - textHeight) / 2 - 24);
      const textShift = clamp(headerBottom + 36 - rect.top - (rect.height - textHeight) / 2, 0, limit);
      const imageShift = clamp((innerHeight / 2 - rect.top - rect.height / 2) * 0.1, -rect.height * 0.06, rect.height * 0.06);
      panel.style.setProperty('--campaign-text-shift', `${textShift}px`);
      panel.style.setProperty('--campaign-image-shift', `${imageShift}px`);
    }
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(update); } }
  function initialize() { panels = [...document.querySelectorAll('[data-campaign-follow="true"]')]; schedule(); }
  addEventListener('scroll', schedule, {passive: true});
  addEventListener('resize', schedule);
  reduced.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(initialize));
  initialize();
})();
